module.exports = __webpack_public_path__ + "img/Gr2.4f12de87.png";